/** Formattatori per l'HUD. Italiano: virgola decimale, punto per le migliaia. */

const num = (v: number, dec = 0): string =>
  v.toLocaleString('it-IT', { minimumFractionDigits: dec, maximumFractionDigits: dec })

export function distanza(m: number): string {
  if (!Number.isFinite(m)) return '—'
  const a = Math.abs(m)
  if (a >= 1_000_000) return `${num(m / 1000, 0)} km`
  if (a >= 10_000) return `${num(m / 1000, 1)} km`
  if (a >= 1_000) return `${num(m / 1000, 2)} km`
  return `${num(m, 0)} m`
}

export function velocita(v: number): string {
  if (!Number.isFinite(v)) return '—'
  return `${num(v, Math.abs(v) < 100 ? 1 : 0)} m/s`
}

export function tempo(s: number): string {
  if (!Number.isFinite(s)) return '—'
  const t = Math.max(0, Math.round(s))
  const h = Math.floor(t / 3600)
  const m = Math.floor((t % 3600) / 60)
  const sec = t % 60
  const due = (n: number) => String(n).padStart(2, '0')
  return h > 0 ? `${h}:${due(m)}:${due(sec)}` : `${m}:${due(sec)}`
}

export function pressione(pa: number): string {
  if (!Number.isFinite(pa)) return '—'
  return pa >= 1000 ? `${num(pa / 1000, 1)} kPa` : `${num(pa, 0)} Pa`
}

export const percento = (v: number): string => `${Math.round(v * 100)}%`
export const gradi = (rad: number): string => `${num((rad * 180) / Math.PI, 0)}°`
export const massa = (kg: number): string =>
  kg >= 1000 ? `${num(kg / 1000, 2)} t` : `${num(kg, 0)} kg`
